export const actionTypes = {
    editMeasurement:'EDIT_MEASUREMENT',
    updateMeasurements:'UPDATE_MEASUREMENTS',
    receiveMeasurements:'RECEIVE_MEASUREMENTS'
 };

export const editMeasurement = (id, value) => ({ type: actionTypes.editMeasurement, id, value });
export const receiveMeasurements = (measurements) => ({ type: actionTypes.receiveMeasurements,measurements});